import {duration, Duration, isDuration} from 'moment';

/**
 * Format the given object according to the given format.
 * If the provided object is a number, it is interpreted
 * as representing the number of (fractional) hours.
 *
 * @param hours either a duration object, or the fractional hours
 * @param format the display format
 *
 * @returns a string representing the formatted duration in hours
 */
export const formatHours = (hours: Duration | number, format: string = 'HH:mm', emptyPlaceHolder: string = '-') : string  => {
    let value = hours;
    if (!isDuration(value)) {
        value = duration(value, 'hours'); // try to parse numbers as hours
    }

    if (value.asMilliseconds() === 0)
        return emptyPlaceHolder;
    else
        return value.format(format, {trim: false})
};
